(function(){
  const vipWrap = document.getElementById('vipCollection10');
  const CURRENT_CURRENCY_CODE = (vipWrap && vipWrap.dataset.currencyCode) ? vipWrap.dataset.currencyCode : 'USD';
  const routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  const PRODUCTS = window.VIP_PRODUCTS || [];
  const PRODUCT_PAGES = window.VIP_PRODUCT_PAGES || {};
  const priceCache = {};

  const svgChevron = `<svg class="vip-select-arrow" viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  const svgLeftArrow = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>`;
  const svgRightArrow = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>`;

  async function getShopifyVariantPrice(variantId) {
    if (priceCache[variantId]) return priceCache[variantId];

    try {
      const response = await fetch(routesRoot + 'variants/' + variantId + '.js', {
        headers: { 'Accept': 'application/json' }
      });

      if (!response.ok) throw new Error('Variant price request failed');

      const data = await response.json();
      const price = Number(data.price) / 100;

      priceCache[variantId] = price;
      return price;
    } catch (e) {
      priceCache[variantId] = 0;
      return 0;
    }
  }

  function formatMoney(val) {
    const amount = Number(val) || 0;

    try {
      return new Intl.NumberFormat(CURRENT_CURRENCY_CODE === 'GBP' ? 'en-GB' : 'en-US', {
        style: 'currency',
        currency: CURRENT_CURRENCY_CODE,
        maximumFractionDigits: 0
      }).format(amount);
    } catch (e) {
      return amount.toFixed(0) + ' ' + CURRENT_CURRENCY_CODE;
    }
  }

  function updateCardPrice(card, price) {
    if (!card) return;

    const formattedPrice = formatMoney(price);
    const badge = card.querySelector('.vip-badge');
    const priceEl = card.querySelector('.vip-price');

    if (badge) badge.textContent = formattedPrice;
    if (priceEl) priceEl.textContent = formattedPrice;
  }

  function setCardLoadingPrice(card) {
    if (!card) return;

    const badge = card.querySelector('.vip-badge');
    const priceEl = card.querySelector('.vip-price');

    if (badge) badge.textContent = 'Loading...';
    if (priceEl) priceEl.textContent = 'Loading...';
  }

  function getVariantParts(variant) {
    const label = variant.label || '';
    const parts = label.split(' - ');
    return {
      size: parts[0] || '',
      color: parts[1] || '',
      style: variant.style || ''
    };
  }

  function findSelectedVariant(product, styleValue, sizeValue, colorValue) {
    return product.variants.find(v => {
      const parts = getVariantParts(v);

      const styleMatches = product.hasStylePicker ? parts.style === styleValue : true;
      const sizeMatches = parts.size === sizeValue;
      const colorMatches = parts.color === colorValue;

      return styleMatches && sizeMatches && colorMatches;
    });
  }

  function createImageCarousel(card, images, initialIndex = 0) {
    const mediaDiv = card.querySelector('.vip-media');
    const imgElement = mediaDiv.querySelector('img');

    if (!mediaDiv || !imgElement || !images || !images.length) return;

    card.imageData = { images: images, currentIndex: initialIndex };
    imgElement.src = images[initialIndex];

    if (!mediaDiv.querySelector('.vip-media-nav')) {
      const prevBtn = document.createElement('div');
      prevBtn.className = 'vip-media-nav prev';
      prevBtn.innerHTML = svgLeftArrow;

      const nextBtn = document.createElement('div');
      nextBtn.className = 'vip-media-nav next';
      nextBtn.innerHTML = svgRightArrow;

      const dotsContainer = document.createElement('div');
      dotsContainer.className = 'vip-media-dots';
      
      images.forEach((_, index) => {
        const dot = document.createElement('div');
        dot.className = `vip-media-dot ${index === initialIndex ? 'active' : ''}`;
        dot.addEventListener('click', (e) => {
          e.stopPropagation();
          card.imageData.currentIndex = index;
          imgElement.src = images[index];
          updateDots(dotsContainer, index);
        });
        dotsContainer.appendChild(dot);
      });

      const navigate = (direction) => {
        let newIndex = card.imageData.currentIndex + direction;
        if (newIndex < 0) newIndex = images.length - 1;
        if (newIndex >= images.length) newIndex = 0;
        card.imageData.currentIndex = newIndex;
        imgElement.src = images[newIndex];
        updateDots(dotsContainer, newIndex);
      };

      prevBtn.addEventListener('click', (e) => { e.stopPropagation(); navigate(-1); });
      nextBtn.addEventListener('click', (e) => { e.stopPropagation(); navigate(1); });

      mediaDiv.appendChild(prevBtn);
      mediaDiv.appendChild(nextBtn);
      mediaDiv.appendChild(dotsContainer);
    }

    function updateDots(container, activeIndex) {
      const dots = container.querySelectorAll('.vip-media-dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === activeIndex);
      });
    }
  }

  function buildCard(product, index){
    const safeId = "vipProd_" + index;
    const firstVariant = product.variants[0];
    const firstImages = firstVariant.images || [];
    const firstImage = firstImages[0] || '';
    const pageUrl = PRODUCT_PAGES[product.title] || "/";
    
    const lowerTitle = product.title.toLowerCase();
    const isBottom = lowerTitle.includes('pants') || lowerTitle.includes('shorts');
    const isTop = lowerTitle.includes('hoodie') || lowerTitle.includes('top');
    const isSet = lowerTitle.includes('set');
    
    let zoomClass = '';
    if (isSet) { 
      zoomClass = 'zoom-center';
    } else if (isBottom) { 
      zoomClass = 'zoom-bottom'; 
    } else if (isTop) { 
      zoomClass = 'zoom-top'; 
    }

    const styles = [...new Set(product.variants.map(v => getVariantParts(v).style).filter(Boolean))];
    const sizes = [...new Set(product.variants.map(v => getVariantParts(v).size).filter(Boolean))];
    const colors = [...new Set(product.variants.map(v => getVariantParts(v).color).filter(Boolean))];

    const styleOptions = styles.map(s => `<option value="${s}">${s}</option>`).join("");
    const sizeOptions = sizes.map(s => `<option value="${s}">${s}</option>`).join("");
    const colorOptions = colors.map(c => `<option value="${c}">${c}</option>`).join("");

    const stylePickerHTML = product.hasStylePicker ? `
      <div class="vip-style-selects">
        <div class="vip-select-wrap">
          <select class="vip-select style-select" data-select-style="${safeId}" aria-label="${product.styleLabel || 'Choose style'}">
            ${styleOptions}
          </select>
          ${svgChevron}
        </div>
      </div>
    ` : '';

    return `
      <div class="vip-card ${zoomClass}" data-card="${safeId}" data-page-url="${pageUrl}">
        <div class="vip-card-overlay"></div>
        <div class="vip-media">
          <div class="vip-badge">Loading...</div>
          <img src="${firstImage}" alt="${product.title}">
        </div>
        <div class="vip-body">
          <div class="vip-row">
            <h3 class="vip-name">${product.title}</h3>
            <p class="vip-price">Loading...</p>
          </div>
          <div class="vip-controls">
            ${stylePickerHTML}
            <div class="vip-split-selects">
              <div class="vip-select-wrap">
                <select class="vip-select size-select" data-select-size="${safeId}">${sizeOptions}</select>
                ${svgChevron}
              </div>
              <div class="vip-select-wrap">
                <select class="vip-select color-select" data-select-color="${safeId}">${colorOptions}</select>
                ${svgChevron}
              </div>
            </div>
            <button class="vip-btn" type="button" data-add="${safeId}">Quick Add</button>
          </div>
        </div>
      </div>
    `;
  }

  function init(){
    const grid = document.getElementById("vipGrid10");
    if (!grid) return;

    grid.innerHTML = PRODUCTS.map(buildCard).join("");

    PRODUCTS.forEach((product, index) => {
      const safeId = "vipProd_" + index;
      const card = grid.querySelector(`[data-card="${safeId}"]`);
      const styleSelect = grid.querySelector(`[data-select-style="${safeId}"]`);
      const sizeSelect = grid.querySelector(`[data-select-size="${safeId}"]`);
      const colorSelect = grid.querySelector(`[data-select-color="${safeId}"]`);
      const btn = grid.querySelector(`[data-add="${safeId}"]`);

      if (!card || !sizeSelect || !colorSelect || !btn) return;

      const firstVariant = product.variants[0];

      if (styleSelect && product.hasStylePicker && firstVariant && firstVariant.style) {
        styleSelect.value = firstVariant.style;
      }

      const firstParts = getVariantParts(firstVariant);
      if (firstParts.size) sizeSelect.value = firstParts.size;
      if (firstParts.color) colorSelect.value = firstParts.color;

      if (firstVariant && firstVariant.images) {
        createImageCarousel(card, firstVariant.images, 0);
      }

      if (firstVariant && firstVariant.variantId) {
        getShopifyVariantPrice(firstVariant.variantId).then(price => {
          updateCardPrice(card, price);
        });
      }

      card.addEventListener('click', (e) => {
        if (!e.target.closest('.vip-select') && 
            !e.target.closest('.vip-btn') && 
            !e.target.closest('.vip-media-nav') &&
            !e.target.closest('.vip-media-dot')) {
          window.location.href = card.getAttribute('data-page-url');
        }
      });

      const updateVariant = () => {
        const styleValue = styleSelect ? styleSelect.value : '';
        const sizeValue = sizeSelect.value;
        const colorValue = colorSelect.value;

        const match = findSelectedVariant(product, styleValue, sizeValue, colorValue);
        if (!match) return;

        if (match.images) {
          const oldNav = card.querySelectorAll('.vip-media-nav, .vip-media-dots');
          oldNav.forEach(el => el.remove());
          createImageCarousel(card, match.images, 0);
        }

        if (match.variantId) {
          setCardLoadingPrice(card);
          getShopifyVariantPrice(match.variantId).then(price => {
            updateCardPrice(card, price);
          });
        }
      };

      if (styleSelect) styleSelect.addEventListener("change", updateVariant);
      sizeSelect.addEventListener("change", updateVariant);
      colorSelect.addEventListener("change", updateVariant);

      btn.addEventListener("click", async (e) => {
        e.stopPropagation();

        const styleValue = styleSelect ? styleSelect.value : '';
        const sizeValue = sizeSelect.value;
        const colorValue = colorSelect.value;

        const selectedVariant = findSelectedVariant(product, styleValue, sizeValue, colorValue);
        
        if (!selectedVariant) return;

        const realPrice = await getShopifyVariantPrice(selectedVariant.variantId);

        const productData = {
          title: product.title,
          variant: selectedVariant.style ? selectedVariant.style + ' - ' + selectedVariant.label : selectedVariant.label,
          price: realPrice,
          variantId: selectedVariant.variantId,
          quantity: 1,
          image: selectedVariant.images ? selectedVariant.images[0] : ''
        };

        if (window.addToCart) {
          btn.textContent = "Added ✓";
          window.addToCart(productData);
          setTimeout(() => { btn.textContent = "Quick Add"; }, 1500);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();